module.exports = __webpack_public_path__ + "img/BackGroundImage.c515e0cf.png";